<template>
  <main-fixed class="search page-report">
    <search
      slot="header"
      :type="showType"
      :group-type="groupType"
      @go-search="goSearch"
      @export-excel="exportExcel"
      @show-type-change="showTypeChange"
      @group-type-change="groupTypeChange"
      @zero-change="showZeroChange"
    ></search>

    <chart
      :show-type="showType"
      :group-type="groupType"
      :loading="loading || gLoading"
      :data="data"
      @actived="activedChange"
    >
      <template slot-scope="prop">
        <data-list
          ref="table"
          :visible="prop.visible"
          :loading="gLoading"
          :group-type="groupType"
          :data="data"
          :actived="actived"
          :show-zero="showZero"
        ></data-list>
      </template>
    </chart>
  </main-fixed>
</template>

<script>
import { getReport } from '@/service/telemetry'
import { export_table_to_excel as exceljs } from '@/utlis/exportExcel'
import { subtract } from '@/utlis/date'
import MainFixed from '@/components/MainFixed'
import Chart from './chart'
import sleep from '@/utlis/sleep'

const Search = () => import('./search')
const DataList = () => import('./list')

export default {
  components: { MainFixed, Search, DataList, Chart },
  data() {
    return {
      loading: false,
      gLoading: false,
      showType: 'preview',
      groupType: 'device',
      showZero: true,
      data: [],
      actived: 0
    }
  },
  computed: {
    // tableData() {
    //   if (this.data && this.data[0]) {
    //     if (this.data[0].devices && this.data[0].devices.length === 1) {
    //       return this.data.map(d => {
    //         return { ...d, devices: [d.devices[0]] }
    //       })
    //     } else {
    //       return this.data.map(d => {
    //         return { ...d, devices: [d.devices[this.actived]] }
    //       })
    //     }
    //   } else {
    //     return []
    //   }
    // },
    statisticPrev() {
      return this.$store.getters.statisticPrev
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(param) {
      this.loading = true
      const [{ data }] = await Promise.all([
        getReport(this.companyId, param),
        sleep(1)
      ])
      this.data = this.statisticPrev
        ? data
        : data.map(d => ({
            ...d,
            date: subtract(d.date, 1, 'days', 'YYYY-MM-DD')
          }))

      this.loading = false
    },
    goSearch(param) {
      if (param.deviceId) delete param.deviceId
      this.getData(param)
    },
    exportExcel(title) {
      exceljs(this.$refs.table.$el, title)
    },
    showTypeChange(type) {
      this.showType = type
    },
    async groupTypeChange(type) {
      this.gLoading = true
      this.groupType = type
      await sleep(1)
      this.gLoading = false
    },
    activedChange(index) {
      this.actived = index
    },
    showZeroChange(v) {
      this.showZero = v
    }
  }
}
</script>

<style lang="css">
.page-report .el-table {
  border: none;
}
</style>
